import { useCallback } from "react"
import { sendMessageToNativeApp } from "../utils/nativeUtils"
import translations from "../utils/translations"

const useTrackingCode = () => {
    const setAppsflyerTrackingCode = useCallback((logName, logData) => {
        try {
            const stringifiedLogData = {
                ...Object.fromEntries(Object.entries(logData).map(([key, value]) => [key, String(value)])),
                partner: translations.TRACKING_CODE.partner,
            }

            sendMessageToNativeApp("setAppsflyerTrackingCode", { logName, logData: stringifiedLogData })
        } catch (error) {
            console.error("Error setting Appsflyer tracking code:", error)
        }
    }, [])

    return { setAppsflyerTrackingCode }
}

export default useTrackingCode
